import { CssBaseline, ThemeProvider } from '@mui/material';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';
import { Toaster } from 'react-hot-toast';
import { BrowserRouter } from 'react-router-dom';

import { AuthProvider } from '@/shared/auth/AuthProvider';
import { theme } from './theme';
import { AppRouter } from './router';

export function App() {
  const [queryClient] = useState(() => new QueryClient({
    defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false }, mutations: { retry: false } },
  }));
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <BrowserRouter><AppRouter /></BrowserRouter>
          <Toaster position="top-right" toastOptions={{ duration: 4500 }} />
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
